import client from 'data/client';
import { CDError } from 'utils/error';

export type Variables = {
  printerCopies: number;
};

export type ResponseStatus = {
  status: string;
};

export const updateGeneralSetting = async ({ printerCopies }: Variables) => {
  try {
    const { data } = await client.post<ResponseStatus>(`/settings/general`, {
      printerCopies,
    });
    return data;
  } catch (error) {
    // @ts-ignore
    throw new CDError(error.toString());
  }
};
